import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { AppContext } from '../util/AppContext';
import { getConfigValue, isBatchPrintEnabledForAnyProduct } from '../util/getConfigValue';
import { focusTypeName } from '../util/constants';
import { useRoutingValidation } from '../util/useRoutingValidation';
import { useBreadcrumbs } from '../util/BreadcrumbContext';
import CreateSalesAidStepProgressBar, { SalesAidStepIds } from '../components/CreateSalesAidStepProgressBar';

function FocusPage() {
    const [appState, setAppState] = useContext(AppContext);
    const navigate = useNavigate();
    const { setBreadcrumbs } = useBreadcrumbs();
    const useStickyNavigation = getConfigValue(appState.config.CreateSalesAid?.Features?.StickyNavigation?.Enabled, appState)?.Value === 'true';
    const hcpOpportunityEnabled = getConfigValue(appState.config?.HCP?.Opportunity?.Enabled, appState)?.Value === "true";
    const batchPrintEnabled = appState.configLoaded ? isBatchPrintEnabledForAnyProduct(appState) : false;

    //Disable the page if batch print is not enabled for any product. 
    useEffect(() => {
        if (!batchPrintEnabled) {
            navigate('/');
        }
    }, [batchPrintEnabled, navigate]);
    
    useEffect(() => {
        setBreadcrumbs([
            { label: getConfigValue(appState.config?.Focus?.Header, appState)?.Value, path: "/FocusPage" }
        ]);
    }, [setBreadcrumbs]);

    useRoutingValidation();

    function handleNavigation(focus) {
		setAppState({
			...appState,
			focus: focus,
		});
		if (appState?.bypassTerritorySelection || (focus === focusTypeName.HCPs && hcpOpportunityEnabled)) {
			if (focus === focusTypeName.HCPs) {
				navigate('/HCPPage');
			} else {
				navigate('/MessageSelectionPage');
			}
		} else {
			navigate('/TerritoryPage');
		}
	}

    return (
        <div>
            <CreateSalesAidStepProgressBar currentStepId={SalesAidStepIds.SELECTPRIMARYFOCUS} />
            <div className="container-xl mt-5">
                <div className="row justify-content-center mb-6">
                    <div className="col-12 col-sm-10 col-lg-8">
                        <h1 className="type-20 color-grey-d1 mb-5">{getConfigValue(appState.config?.Focus?.SelectPrimaryFocus?.Label, appState)?.Value || null}</h1>
                        <div className="card pd-card pt-4 pt-md-7 pb-4 pb-md-7">
                            <div className="row justify-content-center">
                                <div className="col-10 col-md-5 mb-6 mb-md-0">
                                    <button className="btn-tile pt-6 pb-6 mb-3" onClick={() => handleNavigation(focusTypeName.HCPs)}>
                                        <span className="fa-solid fa-user-doctor"></span>
                                        <span className="btn-tile-label">{getConfigValue(appState.config?.Focus?.SelectHCP?.Label, appState)?.Value || null}</span>
                                    </button>
                                    <p className="text-center mb-0">{getConfigValue(appState.config?.Focus?.SelectHCP?.Description?.Label, appState)?.Value || null}</p>
                                </div>
                                <div className="col-10 col-md-5">
                                    <button className="btn-tile pt-6 pb-6 mb-3" onClick={() => handleNavigation(focusTypeName.Messages)}>
                                        <span className="fa-solid fa-envelope-open-text"></span>
                                        <span className="btn-tile-label">{getConfigValue(appState.config?.Focus?.SelectMessage?.Label, appState)?.Value || null}</span>
                                    </button>
                                    <p className="text-center mb-0">{getConfigValue(appState.config?.Focus?.SelectMessage?.Description?.Label, appState)?.Value || null}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`${useStickyNavigation ? 'button-bottom-container-sticky-low-z' : ''}`}>
                <div className='container-xl'>
                    <div className='row justify-content-center justify-content-lg-between py-3'>
                        <div className='col-10 col-sm-8 col-md-6 col-xl-5'>
                            <div className='d-flex flex-column flex-lg-row'>
                                <div className='flex-fill w-100 ms-lg-3 pe-3'></div>
                            </div>
                        </div>
                        <div className='w-100 d-lg-none'></div>
                        <div className={`${useStickyNavigation ? 'col-12' : 'col-10'}`}>
                            <div className='d-flex flex-column flex-lg-row-reverse' style={{ float: "right" }}>
                                <Link to="/RecentSalesAidsPage" className="btn btn-outline-primary btn-lg pe-7 flex-fill w-100">Cancel</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FocusPage;